import React from "react";

const Footer = () => (
    <footer className="footer">
    Mana Tracker is unofficial Fan Content permitted under the Fan Content Policy. Not approved/endorsed by Wizards. Portions of the materials used are property of Wizards of the Coast. ©Wizards of the Coast LLC.
    </footer>
)

export default Footer